export default {
  title: '404',
  subtitle: 'Страница не найдена :(',
  description: 'Такой страницы нет в приложении. Но всегда можно вернуться на главную',
  backButton: 'На главную',
  nothingToShow: 'Ничего не найдено',
}
